module.exports = __webpack_public_path__ + "0502008854ff5ba28abbe556b9bc90ce.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-05-23/whats-new.html
// module id = 2301
// module chunks = 0